import { Box, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material';
import DialogBaseCC from 'components/Dialog/DialogBaseCC';
import { useTranslation } from 'react-i18next';
import { DIALOG_ID } from './constant';

const DialogExpiredService = () => {
    const { t } = useTranslation();

    return (
        <DialogBaseCC id={DIALOG_ID.EXPIRED_SERVICE} title={t('dialog.expired-service.title')}>
            <DialogContent sx={{ maxWidth: '100% !important' }}>
                <DialogContentText sx={{ maxWidth: '100% !important', display: 'flex', flexDirection: 'column' }}>
                    <Box>
                        {t('dialog.expired-service.content-1')} {t('dialog.expired-service.content-2')}{' '}
                        <Typography
                            fontWeight={600}
                            sx={{
                                textDecorationLine: 'underline',
                                fontStyle: 'italic',
                                color: (theme) => theme.palette.secondary.main,
                            }}
                        >
                            {t('dialog.expired-service.content-3')}
                        </Typography>
                        !
                    </Box>
                    <Box>{t('dialog.expired-service.content-4')}</Box>
                    <Box>{t('dialog.expired-service.content-5')}</Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions></DialogActions>
        </DialogBaseCC>
    );
};

export default DialogExpiredService;
